<template>
  <div class="wrapper bg-login-main">
    <!-- Forgot Password Page Start -->
    <div class="m-account-w">
      <div class="m-account">
        <div class="row no-gutters">
          <div class="col-md-12">
            <!-- Forgot Password Form Start -->
            <div class="m-account--form-w">
              <div class="">
                <div @click="abrirLogin" class="back-login">
                  <i class="mdi mdi-arrow-left arrow-back"></i>
                </div>
                <div class="text-center">
                  <img
                    class="d-block mx-auto mb-4"
                    src="@/assets/images/logos/logo-dark.jpg"
                    alt=""
                  />
                  <h2 class="text-secondary">Cadastro de usuário via e-mail</h2>
                  <p class="text-black">
                    Preencha todos os dados obrigatórios e clique em cadastrar.
                  </p>
                </div>
                <div class="row">
                  <div class="col-12">
                    <input-text
                      class="col-12 col-md-12"
                      label="Usuário"
                      v-model="usuario.nomeUsuario"
                      ref="usuario-usuario"
                      required
                    />
                      <b-badge
                      class="col-5 ml-2"
                        v-if="naoDeveConterEspacoECaracteresEspeciais"
                        :variant="naoDeveConterEspacoECaracteresEspeciais.variant"
                      >
                        {{ naoDeveConterEspacoECaracteresEspeciais.text }}
                      </b-badge>
                    </div>
                  <div class="col-6 col-md-6">
                    <div class="col-12 col-md-12">
                      <input-text
                        class="mb-1"
                        type="password"
                        label="Senha"
                        v-model="usuario.senha"
                        ref="usuario-senha"
                        required
                      />
                      <b-badge
                        v-if="deveConter6Caracteres"
                        :variant="deveConter6Caracteres.variant"
                      >
                        {{ deveConter6Caracteres.text }}
                      </b-badge>
                      <br />
                      <b-badge
                        v-if="deveConterLetraMinuscula"
                        :variant="deveConterLetraMinuscula.variant"
                      >
                        {{ deveConterLetraMinuscula.text }}
                      </b-badge>
                      <br />
                      <b-badge
                        v-if="deveConterLetraMaiuscula"
                        :variant="deveConterLetraMaiuscula.variant"
                      >
                        {{ deveConterLetraMaiuscula.text }}
                      </b-badge>
                      <br />
                      <b-badge
                        v-if="deveConterCaracterEspecial"
                        :variant="deveConterCaracterEspecial.variant"
                      >
                        {{ deveConterCaracterEspecial.text }}
                      </b-badge>
                      <br />
                      <b-badge
                        v-if="deveConterNumero"
                        :variant="deveConterNumero.variant"
                        class="mb-2"
                      >
                        {{ deveConterNumero.text }}
                      </b-badge>
                  </div>
                </div>
                <div class="col-6 col-md-6">
                  <input-text
                    class="col-12 col-md-12"
                    type="password"
                    label="Confirme a senha"
                    v-model="usuario.senhaConfirmacao"
                    ref="usuario-confirmasenha"
                    required
                  />
                </div>
                  <div class="col-6">
                    <div class="col-12 col-md-12">
                      <b-button variant="primary" @click="cadastrar"
                        >Cadastrar usuário</b-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import InputText from "@/components/inputs/InputText";

//import helpers from "@/common/utils/helpers";
import PessoaService from "@/common/services/pessoa/pessoa.service";
import UsuarioService from "@/common/services/usuario/usuario.service";

import { FormMixin } from "@/common/mixins/FormMixin";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";

export default {
  props: ["pessoaId", "token"],
  mixins: [FormMixin, AlertasMixin],
  components: {
    InputText,
  },
  data: () => ({
    form: {
      nome: null,
      email: null,
      cpf: null,
      nacionalidade: null,
      telefone: null,
      passaporte: null,
      titulacao: null,
      foto: null,
      celular: null,
      dataNascimento: null,
      endereco: {
        cidade: null,
        uf: null,
      },
      id: null,
      linkCurriculoLattes: null,
    },

    usuario: {
      nomeUsuario: null,
      senha: null,
      senhaConfirmacao: null,
    },
  }),
  methods: {
    buscarPessoa: function () {
      PessoaService.buscarPorId(this.id).then((response) => {
        this.form = response.data.data;
      });
    },
    cadastrar: function () {
      if (this.usuario.senha != this.usuario.senhaConfirmacao) {
        this.alertaErro("As senhas não conferem");
        return;
      }

      if (!this.senhaValida) {
        this.alertaErro(
          "A senha não atende os requisitos mínimos de segurança"
        );
        return;
      }

      if (!this.validarFormulario("usuario-")) return;

      let form = {
        pessoaId: this.pessoaId,
        token: this.token,
        ...this.usuario,
      };

      UsuarioService.criarViaEmail(form)
        .then(() => {
          this.alertaSucesso("Usuário cadastrado com sucesso").then(() => {
            this.abrirLogin();
          });
        })
        .catch((err) => {
          if (err.response.status == 400) {
            this.alertaErro(err.response.data.errors);
          } else this.alertaErro("Erro ao cadastrar usuário");
        });
    },
    abrirLogin() {
      this.$router.push({ name: "Login" });
    },
  },
  mounted() {
    //this.buscarPessoa();
  },
  computed: {
    senhaValida: function () {
      if (
        this.deveConter6Caracteres &&
        this.deveConter6Caracteres.variant == "success" &&
        this.deveConterLetraMaiuscula &&
        this.deveConterLetraMaiuscula.variant == "success" &&
        this.deveConterLetraMinuscula &&
        this.deveConterLetraMinuscula.variant == "success" &&
        this.deveConterCaracterEspecial &&
        this.deveConterCaracterEspecial.variant == "success" &&
        this.deveConterNumero &&
        this.deveConterNumero.variant == "success"
      )
        return true;
      return false;
    },
    deveConter6Caracteres: function () {
      if (!this.usuario.senha) return null;
      if (this.usuario.senha.length < 6)
        return {
          variant: "danger",
          text: "Deve conter no mínimo 6 caracteres",
        };
      return {
        variant: "success",
        text: "Deve conter no mínimo 6 caracteres",
      };
    },
    deveConterLetraMinuscula: function () {
      var letraMinuscula = /([a-z])/;
      if (!this.usuario.senha) return null;
      if (this.usuario.senha.match(letraMinuscula))
        return {
          variant: "success",
          text: "Deve conter letra minúscula",
        };
      return {
        variant: "danger",
        text: "Deve conter letra minúscula",
      };
    },
    deveConterLetraMaiuscula: function () {
      var letraMaiusculas = /([A-Z])/;
      if (!this.usuario.senha) return null;
      if (this.usuario.senha.match(letraMaiusculas))
        return {
          variant: "success",
          text: "Deve conter letra maiúsculas",
        };
      return {
        variant: "danger",
        text: "Deve conter letra maiúsculas",
      };
    },
    deveConterCaracterEspecial: function () {
      var chEspeciais = /([~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<,.])/;
      if (!this.usuario.senha) return null;
      if (this.usuario.senha.match(chEspeciais))
        return {
          variant: "success",
          text: "Deve conter caractere especial",
        };
      return {
        variant: "danger",
        text: "Deve conter caractere especial",
      };
    },
    deveConterNumero: function () {
      var numeros = /([0-9])/;
      if (!this.usuario.senha) return null;
      if (this.usuario.senha.match(numeros))
        return {
          variant: "success",
          text: "Deve conter número",
        };
      return {
        variant: "danger",
        text: "Deve conter número",
      };
    },
    naoDeveConterEspacoECaracteresEspeciais: function () {
      var specialCaracters = /[^\w\\.]/
      if (!this.usuario.nomeUsuario) return null;
      if (this.usuario.nomeUsuario.match(specialCaracters))
      return {
          variant: "danger",
          text: "Não deve conter espaçamento e caracteres especiais",
        };
      return {
        variant: "success",
        text: "Não deve conter espaçamento e caracteres especiais",
      };
    },
  },
};
</script>
<style>
.card {
  min-height: inherit !important;
}
</style>
